const surveyData_en = [
    {
        title: '1. Team Value',
        questions: [
            {
                id: 'q1',
                text: 'Partners\' areas of expertise',
                type: 'radio',
                options: [
                    {
                        option: 'Homogeneous distribution (from various fields)',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "A founding team with diverse expertise, such as technology, sales, and marketing, creates an ideal foundation for success.",
                            "Research shows that teams with complementary skill sets are better equipped to overcome multifaceted challenges.",
                            "This diversity brings a broad perspective to problem-solving processes, resulting in superior performance compared to homogeneous teams.",
                            "Investors view this balanced structure as a significant risk-mitigating factor, as it confirms that critical functions are in expert hands.",
                            "This distribution of competencies gives a strong signal that the company can successfully develop and bring a product to market."
                        ]
                    },
                    {
                        option: 'All software developers',
                        value: 20000,
                        type: 'risk',
                        sentences: [
                            "A founding team consisting entirely of software developers, while possessing a strong technical capacity, carries significant risks in commercial functions.",
                            "Such teams may lack the necessary competencies in areas such as sales, marketing, and financial management.",
                            "This homogeneous structure leads to a focus on technology rather than market needs, increasing the risk that the product will not resonate in the market.",
                            "For investors, this situation is a serious concern regarding the product's commercialization potential.",
                            "The team addressing this lack of competence with external resources will increase initial costs and operational risks."
                        ]
                    },
                    {
                        option: 'All sales professionals',
                        value: 20000,
                        type: 'risk',
                        sentences: [
                            "A team consisting entirely of sales professionals may be excellent at market interaction but lacks the technical capacity to develop the core product.",
                            "This fundamentally makes the venture dependent on outsourced technical talent, which can lead to a disconnect between market feedback and product development.",
                            "The absence of a technical co-founder severely jeopardizes the venture's ability to innovate and quickly adapt to market changes.",
                            "This fundamental deficiency poses a significant risk to the company's long-term viability.",
                            "Investors evaluate this structure as a lack of control over the core product, and this situation can negatively affect the investment decision."
                        ]
                    }
                ]
            },
            {
                id: 'q2',
                text: 'Average business experience per co-founder (years)',
                type: 'radio',
                options: [
                    {
                        option: '5+ years',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Co-founders having an average of more than five years of business experience indicates a team with professional maturity and a deep understanding.",
                            "This level of experience shows a strong correlation with higher success rates, as seasoned founders can leverage their established networks.",
                            "Investors view this as a significant risk-mitigating factor, indicating the team possesses resilience and strategic foresight in the face of challenges.",
                            "This experience allows founders to avoid common startup mistakes and scale the company more efficiently.",
                            "This level of experience serves as a signal of credibility for potential hires and strategic partnerships."
                        ]
                    },
                    {
                        option: '2-5 years',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "This level of experience indicates that the founders have surpassed the entry-level of their careers and possess solid foundational skills.",
                            "They typically have a good balance between modern knowledge and practical experience, which makes them highly agile and adaptable.",
                            "While they may not have the extensive networks of more seasoned professionals, they often stand out with high adaptability and determination to succeed.",
                            "This profile offers a strong foundation for growth and execution potential.",
                            "For investors, this level means the team understands fundamental business processes but is also open to new approaches."
                        ]
                    },
                    {
                        option: '1-2 years',
                        value: 25000,
                        type: 'risk',
                        sentences: [
                            "Founders with one to two years of experience are early in their careers and can bring fresh perspectives.",
                            "However, they often lack the deep industry knowledge and extensive professional networks critical for a startup's survival.",
                            "This inexperience can lead to common mistakes in areas like financial planning and strategic decision-making.",
                            "Investors evaluate this profile as a situation where the team needs more evidence of its ability to handle core business challenges.",
                            "Such teams are typically expected to be supported by strong advisors or mentors."
                        ]
                    },
                    {
                        option: 'Less than 1 year',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "A team with an average of less than one year of professional experience is a major red flag for investors.",
                            "This indicates a team that has not been exposed to professional workflows and the practical difficulties of executing a business.",
                            "The risk of failure is extremely high due to potential gaps in critical business skills.",
                            "This profile raises serious doubts about the venture's capacity to cope with fundamental challenges.",
                            "Investors view investing in such an early-stage team as a high-risk gamble on an unproven hypothesis."
                        ]
                    }
                ]
            },
            {
                id: 'q3',
                text: 'Average industry experience per co-founder (years)',
                type: 'radio',
                options: [
                    {
                        option: '9+ years',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "Extensive industry experience provides the team with deep domain knowledge and valuable industry connections.",
                            "This expertise enables more accurate identification of customer problems and the development of market-fit solutions.",
                            "Investors find this type of experience highly valuable as it reduces the learning curve and lowers the risk of market entry.",
                            "This in-depth knowledge strengthens the company's strategic positioning and creates a competitive advantage.",
                            "Credibility in the industry facilitates attracting initial customers and strategic partners."
                        ]
                    },
                    {
                        option: '7-9 years',
                        value: 40000,
                        type: 'potential',
                        sentences: [
                            "This experience range indicates that the founders have a solid track record and reputation in the industry.",
                            "They are assumed to be competent in understanding the competitive landscape, key players, and market nuances.",
                            "This level of experience is sufficient to establish credibility with both customers and investors.",
                            "Founders can anticipate market trends and steer the company in the right direction thanks to this experience.",
                            "This reduces the probability of strategic errors and allows the venture to navigate the market faster."
                        ]
                    },
                    {
                        option: '5-7 years',
                        value: 30000,
                        type: 'potential',
                        sentences: [
                            "Five to seven years of industry experience is a strong indication that the founders understand the market and its core dynamics.",
                            "This level provides a sufficient foundation for making informed decisions in the initial stages of the venture.",
                            "Founders are experienced enough to recognize the main challenges and opportunities in the sector.",
                            "They may not yet possess the deep networks or nuanced insights held by the most seasoned experts.",
                            "Nevertheless, this experience offers a significant advantage for the venture to make a solid start in the market."
                        ]
                    },
                    {
                        option: '2-5 years',
                        value: 10000,
                        type: 'potential',
                        sentences: [
                            "This experience range indicates a basic understanding of the industry and is better than no experience.",
                            "Founders are familiar with the basic functioning of the market but may have limited knowledge of the sector's complexities.",
                            "This means they will face a steeper learning curve compared to more experienced competitors.",
                            "Investors will want to see how these teams plan to compensate for their shortcomings through consulting or strategic hires.",
                            "While this level of experience presents some potential, it also indicates a significant area for development."
                        ]
                    },
                    {
                        option: '1-2 years',
                        value: 5000,
                        type: 'risk',
                        sentences: [
                            "Limited industry experience suggests that the team has only superficial knowledge of the market.",
                            "This increases the risk of misunderstanding the target audience's needs.",
                            "The probability of developing an ineffective market entry strategy is high.",
                            "The venture starts with a significant disadvantage when competing with established players in the sector.",
                            "This lack of experience is a concern for investors, and the team's learning ability must be exceptional."
                        ]
                    },
                    {
                        option: 'Less than 1 year',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Lack of relevant industry experience is a major risk factor and a serious red flag for investors.",
                            "The team will have to learn the industry from scratch, which increases the probability of making strategic mistakes.",
                            "The risk of misinterpreting market needs and developing a product that does not resonate with the target audience is high.",
                            "This forces investors to bet solely on the team's exceptionally fast learning ability.",
                            "The venture will require significant external expertise to close this large knowledge gap."
                        ]
                    }
                ]
            },
            {
                id: 'q4',
                text: 'Number of co-founders',
                type: 'radio',
                options: [
                    {
                        option: '1 co-founder',
                        value: 12500,
                        type: 'risk',
                        sentences: [
                            "Solo founders take on the entire workload themselves and have a limited perspective in decision-making processes.",
                            "This significantly increases the risk of burnout.",
                            "They often lag behind multi-founder companies in terms of revenue.",
                            "They have been shown to take longer to scale.",
                            "For investors, this reliance on a single person is a major concern, referred to as 'key person risk'."
                        ]
                    },
                    {
                        option: '2 co-founders',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A two co-founder team usually strikes an ideal balance between sharing the workload and combining different skill sets.",
                            "This structure allows for faster decision-making compared to larger teams.",
                            "It eliminates the isolation and skill gaps faced by a solo founder.",
                            "Research shows that two co-founder teams progress faster than solo founders.",
                            "This structure offers the optimal balance for both operational efficiency and psychological resilience."
                        ]
                    },
                    {
                        option: '3 co-founders',
                        value: 37500,
                        type: 'potential',
                        sentences: [
                            "A three co-founder team can be highly effective, allowing for a broader distribution of talent.",
                            "It provides a natural balance mechanism in decision-making processes.",
                            "However, this structure introduces more interpersonal dynamics and can complicate equity distribution.",
                            "Clear definition of roles and responsibilities is vital to prevent conflicts.",
                            "In three-person teams, political risks may arise, such as two co-founders ganging up to exclude the third."
                        ]
                    },
                    {
                        option: '4 co-founders',
                        value: 25000,
                        type: 'risk',
                        sentences: [
                            "A four-person founding team increases the risk of delays in decision-making and conflicts among co-founders.",
                            "Investors may question the necessity of so many founders, as it can indicate inefficiency.",
                            "The reduction in equity for each member can negatively affect individual motivation and long-term commitment.",
                            "The diffusion of responsibility can make accountability difficult.",
                            "This structure often carries the potential to lead to internal strife."
                        ]
                    },
                    {
                        option: '4+ co-founders',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Teams with more than four co-founders are a major red flag for investors.",
                            "The complexity of managing relationships and aligning visions increases exponentially.",
                            "This often leads to paralysis and internal conflicts.",
                            "Paul Graham from YCombinator states that such teams are less likely to be among the top performers.",
                            "This structure makes management difficult and severely hampers the venture's agility."
                        ]
                    }
                ]
            },
            {
                id: 'q5',
                text: 'Global market experience (at least 1 entrepreneur is sufficient)',
                type: 'radio',
                options: [
                    {
                        option: '5+ years',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Extensive global market experience provides a deep competitive advantage for ventures with international ambitions.",
                            "Founders with this background have a nuanced understanding of cross-cultural business practices and different regulatory environments.",
                            "Research shows that founders with international experience pursue more successful internationalization strategies.",
                            "This experience significantly reduces the risks and uncertainties inherent in global expansion.",
                            "Investors view this experience as a strong indicator of the venture's potential for global success."
                        ]
                    },
                    {
                        option: '2-5 years',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "This level of experience indicates a basic understanding of international markets and that the team is aware of the complexities of global expansion.",
                            "Founders are knowledgeable about issues such as localization and navigating different legal frameworks.",
                            "This experience reduces the risk associated with a venture's first international move.",
                            "It allows for the creation of a more informed strategy.",
                            "The team has high potential to enter more complex global markets using this foundational knowledge."
                        ]
                    },
                    {
                        option: '1-2 years',
                        value: 25000,
                        type: 'potential',
                        sentences: [
                            "One to two years of global experience indicates some familiarity with international business, but it is generally limited.",
                            "The team may understand the fundamental challenges of global markets but may be insufficient in in-depth strategic planning.",
                            "This level of experience is better than none.",
                            "However, it will still require a significant learning curve.",
                            "The venture may need international consultants or local partners to compensate for this lack of experience."
                        ]
                    },
                    {
                        option: 'None',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "A complete lack of global market experience means the venture is unprepared for the challenges of international expansion.",
                            "These challenges include unfamiliar cultural nuances, complex regulatory hurdles, and intense global competition.",
                            "Without this experience, the team is likely to underestimate the required resources and strategic adaptations.",
                            "This turns global growth into a high-risk, high-cost endeavor.",
                            "Investors view this deficiency as a factor that seriously limits the venture's scaling potential."
                        ]
                    }
                ]
            },
            {
                id: 'q6',
                text: 'Has any of the founders had previous entrepreneurial experience?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Having previous experience as an entrepreneur is extremely valuable, even if it was a failed venture.",
                            "This experience provides firsthand knowledge of the entire startup lifecycle, from ideation to fundraising.",
                            "'Serial entrepreneurs' have learned from past mistakes, established relevant networks, and demonstrated the resilience investors look for.",
                            "This experience allows the new venture to avoid common pitfalls and progress faster.",
                            "This experience is one of the most sought-after profiles by investors."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Those who have never been exposed to the world of entrepreneurship face the steepest learning curve.",
                            "They are more likely to make common and preventable mistakes in areas such as product-market fit and team building.",
                            "While passion and a great idea are important, the lack of execution experience is one of the primary reasons startups fail.",
                            "This makes this profile high-risk for investors.",
                            "It is critically important for these teams to have a strong advisory network to compensate for their lack of experience."
                        ]
                    }
                ]
            },
            {
                id: 'q7',
                text: 'Co-founder working full-time at the company',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "The full-time dedication of founders is a non-negotiable requirement for most investors.",
                            "This sends an unwavering signal of commitment that the team is fully invested in managing the intense demands of building a company.",
                            "This 'all-in' approach is critical for overcoming hurdles and ensuring growth.",
                            "Investors prefer to invest their capital in teams fully dedicated to the venture.",
                            "This commitment is the most tangible evidence of belief in success."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Lack of a full-time commitment is one of the biggest red flags for an early-stage venture.",
                            "This indicates that the founders are not fully dedicated and are hedging their risks.",
                            "Divided attention severely limits the venture's ability to execute, innovate, and compete.",
                            "This makes it an uninvestable proposition for most venture capitalists.",
                            "Entrepreneurship is too demanding a process to succeed as a part-time effort."
                        ]
                    }
                ]
            },
            {
                id: 'q8',
                text: 'What is the size of the co-founder\'s accessible network?',
                type: 'radio',
                options: [
                    {
                        option: '5000+ people',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A large professional network is a critical intangible asset that directly impacts a venture's success.",
                            "A large network provides access to potential customers, strategic partners, key personnel, and investors.",
                            "Research shows a strong correlation between a founder's centrality in a network and fundraising success.",
                            "This extensive network allows the venture to move faster in the market and capture opportunities more efficiently.",
                            "This can be a decisive advantage, especially in highly competitive sectors."
                        ]
                    },
                    {
                        option: 'Between 3000-5000 people',
                        value: 37500,
                        type: 'potential',
                        sentences: [
                            "A network of this size indicates the founder is a well-connected professional and carries significant value.",
                            "It forms a solid foundation for the venture to access initial resources and opportunities.",
                            "Strategically mobilizing this network and growing it to meet the venture's specific needs will be key to success.",
                            "The founder is expected to enable the venture to reach its goals by deepening and expanding these existing relationships.",
                            "This network can serve as a significant leverage point in the company's growth journey."
                        ]
                    },
                    {
                        option: 'Between 1000-3000 people',
                        value: 25000,
                        type: 'potential',
                        sentences: [
                            "A network of this size offers a professional foundation but may need development to support the venture's growth goals.",
                            "The founder should use existing connections as a starting point but proactively expand their network by building new relationships.",
                            "The limitations of this network may become more apparent during the fundraising and strategic partnership process.",
                            "Therefore, network development should be one of the founder's primary tasks.",
                            "Actively managing this network is important to maximize the venture's potential."
                        ]
                    },
                    {
                        option: 'Between 0-1000 people',
                        value: 12500,
                        type: 'risk',
                        sentences: [
                            "A smaller network limits the founder's ability to easily access external resources and opportunities.",
                            "While not an insurmountable obstacle, it means the team will need to put in significantly more effort to build connections.",
                            "This can slow down progress and complicate the fundraising process.",
                            "Finding mentors and getting introductions to investors may take more time.",
                            "The venture will need to implement active participation in ecosystem events and proactive networking strategies to address this deficiency."
                        ]
                    }
                ]
            },
            {
                id: 'q9',
                text: 'What is the motivation and commitment of the team members?',
                type: 'radio',
                options: [
                    {
                        option: 'High motivation, commitment, and low employee turnover',
                        value: 125000,
                        type: 'potential',
                        sentences: [
                            "A highly motivated and committed team is a strong indicator of healthy leadership and a positive work culture.",
                            "This environment fosters the innovation, productivity, and resilience necessary to cope with the pressures of a startup.",
                            "Low employee turnover retains valuable institutional knowledge and signals to investors that the team is stable.",
                            "This significantly increases the company's likelihood of achieving its long-term goals.",
                            "This kind of culture also acts as a magnet for attracting and retaining top talent."
                        ]
                    },
                    {
                        option: 'Moderate motivation',
                        value: 25000,
                        type: 'potential',
                        sentences: [
                            "Moderate motivation can point to potential issues in leadership, vision, or the work environment.",
                            "While not a critical failure, it can prevent the venture from operating at peak performance.",
                            "This can lead to slower execution and less innovation.",
                            "This is a warning sign that requires proactive management to prevent a decline in morale and performance.",
                            "It is critically important for leadership to take steps to understand and address the root causes of the lack of motivation."
                        ]
                    },
                    {
                        option: 'Low motivation, high turnover risk',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "This is a critical red flag, indicating deep-seated problems within the company, such as leadership failure or a toxic culture.",
                            "High employee turnover is costly, disruptive, and a clear sign of internal dysfunction.",
                            "Investors view this as a major execution risk.",
                            "An unmotivated and unstable team is unlikely to achieve its goals.",
                            "This indicates that the venture is fundamentally flawed and has a very low chance of sustainable success."
                        ]
                    }
                ]
            },
        ]
    },
    {
        title: '2. Value of the Idea',
        questions: [
            {
                id: 'q10',
                text: 'How clear and important is the problem your venture aims to solve?',
                type: 'radio',
                options: [
                    {
                        option: 'Problem is large, solution is viable and scalable',
                        value: 125000,
                        type: 'potential',
                        sentences: [
                            "This option represents the ideal situation: identifying a significant problem for a well-defined customer segment.",
                            "This clarity demonstrates a deep understanding of the customer's pain points and is the cornerstone of a successful startup.",
                            "The venture proves that it is not just developing a product but is on the path to building a sustainable business.",
                            "For investors, this means the market need is validated and the solution carries commercial potential.",
                            "This approach significantly increases the venture's likelihood of succeeding in the market and creating long-term value."
                        ]
                    },
                    {
                        option: 'Problem is specific, solution is being tested',
                        value: 65000,
                        type: 'potential',
                        sentences: [
                            "The venture has defined a problem but is in the process of validating the solution.",
                            "This is a common early stage where an initial solution is being tested to gather feedback.",
                            "The core risk here is that the current solution may not adequately address the problem, necessitating pivots.",
                            "This stage is a period of high uncertainty but equally high learning potential.",
                            "Investors closely monitor how quickly a venture at this stage responds to feedback and its ability to learn."
                        ]
                    },
                    {
                        option: 'Problem is unclear, solution is limited',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "This scenario represents the highest risk situation, often described as 'a solution looking for a problem'.",
                            "The venture is focused on developing a product based on assumptions rather than validated customer needs.",
                            "This is one of the primary causes of failure.",
                            "Without a clearly defined and important problem, there is no foundation for a sustainable business.",
                            "The risk of all invested resources being wasted is high."
                        ]
                    }
                ]
            },
            {
                id: 'q11',
                text: 'Is the problem a costly and significant area?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Solving a costly or high-value problem for customers establishes a strong foundation for a viable business model.",
                            "Customers are more willing to pay for solutions that save them significant money or mitigate major risks.",
                            "This translates to higher potential revenue per customer and a clearer value proposition.",
                            "Focusing on such a problem allows the venture to be adopted more easily in the market and grow faster.",
                            "This also sets the stage for pricing power and higher profit margins."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Targeting a problem that is not costly or significant for the customer makes it difficult to build a sustainable business.",
                            "Customers are unlikely to pay for a 'nice-to-have' type of solution.",
                            "This leads to difficulties in commercialization and achieving product-market fit.",
                            "It often results in low conversion rates and high customer churn.",
                            "Investors find such ventures risky due to the low potential for creating a scalable revenue model."
                        ]
                    }
                ]
            },
            {
                id: 'q12',
                text: 'Was field feedback received during the product development process?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 125000,
                        type: 'potential',
                        sentences: [
                            "Actively seeking customer feedback is the cornerstone of the Lean Startup methodology.",
                            "This shows the team is focused on 'validated learning' rather than unproven assumptions.",
                            "This customer-centric approach significantly increases the chances of achieving Problem-Solution Fit.",
                            "The feedback loop prevents the waste of resources and ensures the product becomes more market-fit.",
                            "For investors, this is the strongest evidence that the team can make market-responsive and data-driven decisions."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Developing a product without customer feedback is one of the most fatal mistakes a venture can make.",
                            "This means the team is operating purely on intuition and assumptions, which have a high probability of being wrong.",
                            "This approach leads to a waste of time and resources by building features nobody needs.",
                            "Investors see this as a fundamental methodological error that maximizes the venture's risk of failure.",
                            "Products developed without market contact are almost always doomed to fail."
                        ]
                    }
                ]
            },
            {
                id: 'q13',
                text: 'Will the importance of the problem continue over the next 5 years?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Targeting a resilient and long-term problem ensures the venture addresses a sustainable market need.",
                            "This provides a foundation for long-term growth and makes the venture more attractive to investors.",
                            "It indicates that the market opportunity is not temporary and will be supportive as the company scales.",
                            "This signals that the venture has the potential to create lasting value.",
                            "Focusing on a sustainable problem allows time for brand building and establishing a market leadership position."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Focusing on a short-term problem or a passing trend creates a high-risk business model with limited long-term potential.",
                            "The market for the solution could disappear, invalidating the product and making it impossible to build a sustainable company.",
                            "Investors are cautious about such ventures because they lack long-term, scalable return potential.",
                            "This type of business model typically does not provide enough time to build a lasting competitive advantage.",
                            "The venture is pressured to generate profit quickly before the market vanishes."
                        ]
                    }
                ]
            },
            {
                id: 'q14',
                text: 'Does solving this problem require specialized or advanced technical knowledge or expertise?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "A problem that requires specialized, above-average competence to solve creates a natural barrier to entry for competitors.",
                            "This technical or domain-specific complexity can be a strong defense mechanism or 'moat'.",
                            "This indicates that the founding team possesses unique skills that make their solution difficult to replicate.",
                            "Investors highly value such technical barriers as an indicator of the venture's ability to protect its long-term profit margins.",
                            "This is a significant factor that positively affects the venture's valuation."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "If the solution to the problem is simple and does not require specialized skills, the barrier to market entry is low.",
                            "This means the venture will face intense competition from new entrants who can easily replicate the product.",
                            "Without a strong defensive advantage, the business may be forced to compete solely on price.",
                            "This leads to low profit margins and a difficult path to profitability.",
                            "For investors, this is a concern because it is difficult to establish sustainable market leadership."
                        ]
                    }
                ]
            },
        ]
    },
    {
        title: '3. Market Assessment',
        questions: [
            {
                id: 'q20',
                text: 'Please select the technology field you are working in:',
                type: 'radio',
                options: [
                    {
                        option: 'Artificial Intelligence (AI)',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "The Artificial Intelligence sector is one of the fastest-growing and highest-potential fields in the technology world.",
                            "The global AI market is expected to reach $1.77 trillion by 2032, offering immense growth potential.",
                            "AI technologies create transformative effects in almost every sector, offering broad application areas.",
                            "Ventures operating in this field encounter strong investor interest and exponential growth potential.",
                            "AI solutions provide major advantages in terms of scalability and global market access."
                        ]
                    },
                    {
                        option: 'Blockchain',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Blockchain technology has the potential to revolutionize many areas, such as finance, supply chain, and digital identity.",
                            "Decentralized financial systems (DeFi) and Web3 technologies are rapidly evolving and creating new business models.",
                            "This technology offers alternative solutions to traditional systems with its security, transparency, and decentralized structure.",
                            "Ventures in the Blockchain space are receiving significant attention from early-stage investors.",
                            "As the technology matures, corporate adoption is rapidly increasing."
                        ]
                    },
                    {
                        option: 'Cybersecurity',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Driven by increasing cyber threats, the cybersecurity sector has become a critically important and rapidly growing area.",
                            "With the rise of digitalization, the demand for security solutions is constantly increasing.",
                            "This sector offers a broad market for both corporate and individual customers.",
                            "Cybersecurity ventures are characterized by high profitability potential and strong customer loyalty.",
                            "With the pace of technological advancements, there is a continuous need for solutions to prevent new security threats."
                        ]
                    },
                    {
                        option: 'Health Technologies',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "The health technologies sector has significant growth potential due to the aging population and increasing healthcare needs.",
                            "Digital health solutions, telemedicine, and AI-supported diagnostic systems are being rapidly adopted.",
                            "The COVID-19 pandemic accelerated the adoption of health technologies and triggered market growth.",
                            "This field offers the opportunity to create both social impact and achieve commercial success.",
                            "The digital transformation in the healthcare sector is creating major opportunities for innovative ventures."
                        ]
                    },
                    {
                        option: 'FinTech',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "The FinTech sector has gained a significant market share by transforming traditional financial services.",
                            "Digital payments, lending, and investment platforms are rapidly growing and reaching new customer segments.",
                            "This sector is supported by strong regulatory backing and increasing consumer acceptance.",
                            "FinTech ventures are characterized by high growth rates and strong investor interest.",
                            "The rise of financial inclusion continues to create new opportunities in this field."
                        ]
                    },
                    {
                        option: 'Green Technologies',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "The focus on climate change and sustainability is rapidly growing the green technologies sector.",
                            "Major investments are being made in renewable energy, carbon capture, and sustainable production.",
                            "Government incentives and regulatory changes are supporting ventures in this sector.",
                            "Green technology ventures offer the opportunity for both environmental impact and commercial success.",
                            "Corporate sustainability goals are increasing the demand for solutions in this area."
                        ]
                    },
                    {
                        option: 'EdTech',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "The education technologies sector is rapidly growing with the proliferation of remote learning and digital education tools.",
                            "The COVID-19 pandemic accelerated the adoption of EdTech solutions and triggered market growth.",
                            "Personalized learning and AI-supported educational platforms hold great potential.",
                            "This sector offers a broad market for both individual and corporate customers.",
                            "The widespread adoption of the lifelong learning concept is creating a continuously growing market for EdTech ventures."
                        ]
                    },
                    {
                        option: 'Cloud Computing',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "The cloud computing sector is continuously growing as a cornerstone of digital transformation.",
                            "The shift of businesses to remote work models has increased the demand for cloud technologies.",
                            "SaaS, PaaS, and IaaS models offer various business model opportunities for ventures.",
                            "This sector is characterized by high scalability and recurring revenue potential.",
                            "New trends such as edge computing and hybrid cloud solutions are creating additional growth opportunities."
                        ]
                    },
                    {
                        option: 'Electric / Autonomous Vehicles',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Electric and autonomous vehicle technologies are creating a major transformation in the automotive sector.",
                            "Government incentives and environmental regulations are accelerating growth in this area.",
                            "Major investments are being made in battery technology, autonomous driving, and charging infrastructure.",
                            "This sector offers various venture opportunities in terms of both technology and manufacturing.",
                            "Smart transportation systems and mobility services are creating additional market segments."
                        ]
                    },
                    {
                        option: 'Agricultural Technologies (AgriTech)',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "The AgriTech sector holds great potential due to the increasing need for food and the search for sustainable agriculture.",
                            "Technologies such as smart farming, precision agriculture, and vertical farming are rapidly developing.",
                            "Climate change and resource scarcity are increasing the demand for agricultural technologies.",
                            "This field offers the opportunity to create both social impact and achieve commercial success.",
                            "The application of IoT, AI, and robotics technologies in agriculture is creating new business models."
                        ]
                    },
                    {
                        option: 'Sustainability',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Sustainability technologies are rapidly growing, driven by climate goals and a focus on corporate responsibility.",
                            "There are major opportunities in carbon footprint management, circular economy, and sustainable production.",
                            "ESG goals and regulatory changes are increasing the demand for solutions in this sector.",
                            "Sustainability ventures encounter strong investor interest and opportunities for corporate partnerships.",
                            "The increase in consumer awareness is creating a growing market for sustainable technologies."
                        ]
                    },
                    {
                        option: 'IoT (Internet of Things)',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "IoT technologies have entered a mature growth phase with the concepts of Industry 4.0 and smart cities.",
                            "This field offers opportunities for increased efficiency and cost reduction across various sectors.",
                            "IoT solutions are situated in an established market segment with stable growth potential.",
                            "Sensor technologies and connectivity solutions are creating a continuously evolving and expanding ecosystem.",
                            "Industrial IoT applications carry the potential to create measurable value for businesses."
                        ]
                    },
                    {
                        option: 'VR / AR (Virtual and Augmented Reality)',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "VR/AR technologies are increasingly being adopted in education, entertainment, and industrial applications.",
                            "The Metaverse concept and remote work trends are increasing interest in these technologies.",
                            "This field is in the process of technological maturation and is discovering new application areas.",
                            "VR/AR solutions show growth potential, particularly in corporate training and marketing.",
                            "The decline in hardware costs is enabling these technologies to reach broader audiences."
                        ]
                    },
                    {
                        option: 'E-commerce & Digital Marketing',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "E-commerce and digital marketing, despite being mature markets, still offer growth opportunities.",
                            "New technologies and changing consumer behaviors are creating innovation opportunities in this area.",
                            "Strong differentiation and focus on niche markets are necessary to succeed in this sector.",
                            "Trends like social commerce, voice commerce, and AI-powered personalization are generating growth.",
                            "Omnichannel experiences and customer data analysis can provide a competitive edge."
                        ]
                    },
                    {
                        option: 'Robotics',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "Robotics technologies show steady growth in industrial automation and service robots.",
                            "Demand for robotic solutions is increasing in the manufacturing and logistics sectors.",
                            "This field is finding new application areas with technological advancements.",
                            "Robotics ventures have the potential to create value, especially in the B2B segment.",
                            "Human-robot collaboration and collaborative robots are forming a growing market segment."
                        ]
                    },
                    {
                        option: '3D Printing',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "3D printing technologies are maturing by transitioning from the prototyping stage to production.",
                            "The need for customization and small-batch production demands are creating growth in this area.",
                            "Applications of 3D printing are increasing in the healthcare, aviation, and automotive sectors.",
                            "This technology is gaining market share by offering alternative solutions to traditional manufacturing methods.",
                            "Advances in material technology are expanding the application areas of 3D printing."
                        ]
                    },
                    {
                        option: 'Gaming',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "The gaming sector shows steady growth with mobile games and online gaming platforms.",
                            "E-sports and game streaming platforms are creating new revenue streams in the sector.",
                            "This field is a sector where creativity and technology merge, with broad audience engagement.",
                            "In-game purchases and subscription models provide sustainable revenue streams.",
                            "VR games and augmented reality experiences are creating new growth areas in the sector."
                        ]
                    },
                    {
                        option: 'Other',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "There are successful startup examples in various other technology fields as well.",
                            "Niche markets and custom solutions can hold great success potential.",
                            "Every sector has its unique opportunities and growth dynamics.",
                            "Original business models and innovative approaches can create success in any field.",
                            "Focusing on creating value and solving customer problems is more important than market size."
                        ]
                    }
                ]
            },
            {
                id: 'q21',
                text: 'Market size',
                type: 'radio',
                options: [
                    {
                        option: 'Very large, international market',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "A very large and international Total Addressable Market (TAM) indicates the potential for a 'unicorn' level outcome.",
                            "This allows the company to build a billion-dollar business by capturing even a small portion of the market.",
                            "Diversity within the market offers additional advantages and opportunities to develop multiple product lines.",
                            "For investors, this means the growth potential is almost limitless.",
                            "This scale acts as leverage to attract top talent and establish large-scale strategic partnerships."
                        ]
                    },
                    {
                        option: 'Large, with high growth potential',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "A large Serviceable Available Market (SAM) with strong growth dynamics is highly attractive.",
                            "This indicates the existence of a clear and accessible market segment that the venture can realistically target.",
                            "A high growth rate implies that the market is expanding and acquiring new customers is easier.",
                            "This means that market entry can be less costly and less frictional.",
                            "Investors see such markets as a fertile ground where the venture can quickly gain market share."
                        ]
                    },
                    {
                        option: 'Medium-sized, with growth potential',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A medium-sized market requires the venture to capture a more significant portion of its Serviceable Obtainable Market (SOM) to be successful.",
                            "While a viable business can be built in this market, the limited ceiling on market size may restrict the ultimate return potential.",
                            "This can make it a less attractive proposition for top-tier venture capital funds.",
                            "The venture needs to have a very clear niche strategy to become a leader in this market.",
                            "Delivering a superior product or service is critical for success in this market."
                        ]
                    },
                    {
                        option: 'Niche, more limited market',
                        value: 25000,
                        type: 'risk',
                        sentences: [
                            "A small, local, or niche market severely restricts a venture's growth potential.",
                            "Such businesses are often considered 'lifestyle businesses' rather than companies that can scale with venture capital.",
                            "A limited TAM means that even if 100% of the market is captured, the revenue potential is insufficient.",
                            "Therefore, such ventures are generally not considered suitable for venture capital investment.",
                            "These markets offer sustainable but limited growth potential."
                        ]
                    }
                ]
            },
            {
                id: 'q22',
                text: 'Competition in the market',
                type: 'radio',
                options: [
                    {
                        option: 'No strong competitors yet',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "Entering a 'blue ocean' market with no strong competitors provides a significant first-mover advantage.",
                            "The venture has the opportunity to define the market and capture significant market share.",
                            "It can build strong brand recognition before others enter.",
                            "This is a highly desirable scenario, but it is necessary to validate the market's existence.",
                            "If successful, this venture can set the standard for the market."
                        ]
                    },
                    {
                        option: 'No competitors',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Although seemingly positive, a complete lack of competitors can be a warning sign.",
                            "This might indicate that the market does not exist or the problem is not significant enough to solve.",
                            "There is a possibility that previous ventures have failed for non-obvious reasons.",
                            "This scenario requires extra due diligence to confirm whether the venture has found a truly undiscovered opportunity or a 'market mirage'.",
                            "Investors will demand more data to prove the market's existence in this case."
                        ]
                    },
                    {
                        option: 'There are strong, large competitors',
                        value: 50000,
                        type: 'risk',
                        sentences: [
                            "Competing against strong, established competitors ('red ocean') is challenging and capital-intensive.",
                            "The venture must have a clear and compelling point of differentiation to succeed.",
                            "This could be a 10x better product, a disruptive business model, or a unique distribution channel.",
                            "Without a significant competitive advantage, established competitors can crush new entrants.",
                            "Success in this market often requires focusing on a niche area."
                        ]
                    },
                    {
                        option: 'There is disruptive competition',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "It is extremely difficult for a startup to survive in a market with disruptive, price-war-focused competition.",
                            "Startups lack the scale and capital reserves needed to compete on price.",
                            "This leads to unsustainable cash burn rates and compressed profit margins.",
                            "This environment is a major red flag for investors because the path to profitability is unclear.",
                            "In such markets, value is destroyed rather than created, making it one of the most undesirable scenarios for a venture."
                        ]
                    }
                ]
            },
            {
                id: 'q23',
                text: 'What is the impact of new developing technology in the market on your product?',
                type: 'radio',
                options: [
                    {
                        option: 'Positive (supports its growth, creates new opportunities)',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "Aligning the venture's product with a major technological trend, like artificial intelligence, provides it with a 'market tailwind'.",
                            "This makes the product more relevant, powerful, and scalable over time.",
                            "This alignment shows that the team is forward-thinking and building a solution for the future.",
                            "Investors see this positioning as a sign of the venture's ability to use waves of technological change as an opportunity.",
                            "This increases the venture's long-term viability and growth potential."
                        ]
                    },
                    {
                        option: 'Negative (slows or stops its growth)',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Being on the wrong side of a technological shift means the venture's product is at risk of disruption or obsolescence.",
                            "For example, offering an on-premise software solution when an industry is rapidly moving to the cloud.",
                            "This is a critical strategic risk that threatens the long-term viability of the entire venture.",
                            "Investors avoid ventures that go against the market or risk being technologically left behind.",
                            "This can cause the venture to lose market share and eventually become irrelevant."
                        ]
                    }
                ]
            },
            {
                id: 'q24',
                text: 'Have you pivoted?',
                tooltip: 'Pivot: A strategic change of direction in the business model made with user feedback or market conditions.',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "A history of a data-driven pivot is viewed positively by many investors.",
                            "This shows that the team is adaptable and responsive to market feedback.",
                            "It proves they are not emotionally attached to a failing idea.",
                            "A successful pivot is a strong signal of a resilient team that prioritizes finding product-market fit.",
                            "This demonstrates the team's ability to learn and evolve, which is one of the most important traits for an early-stage venture."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "This is not negative if the venture has found early traction.",
                            "However, if other metrics are weak, a 'No' answer can be a concern.",
                            "It might indicate that the team is either not listening to market feedback or is too rigid in its thinking.",
                            "Investors will want to understand if the lack of a pivot stems from early success or a dangerous mindset.",
                            "Not pivoting, especially if Problem-Solution Fit is unproven, can signal that the team is unable to manage its learning cycle."
                        ]
                    }
                ]
            },
            {
                id: 'q25',
                text: 'What is the level of regulatory dependence? Is there a legal regulation that supports the sale of the product?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A supportive legal regulation acts as a strong market tailwind and a barrier to entry.",
                            "If a law creates a need for the venture's product, this can create a 'captive market' and accelerate adoption.",
                            "This reduces the risk in the market demand component of the business.",
                            "It gives the venture instant legitimacy in the market.",
                            "Such regulations can also make it difficult for new competitors to enter the market, providing a protective shield for the existing venture."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Operating in a regulatory gray area or facing potential adverse regulations brings significant uncertainty and risks.",
                            "Adverse regulatory changes can destroy a business model overnight.",
                            "This regulatory risk can deter investors who cannot predict the long-term viability of the market.",
                            "This uncertainty makes it difficult for the venture to scale and make long-term plans.",
                            "This makes it a less attractive investment."
                        ]
                    }
                ]
            },
            {
                id: 'q26',
                text: 'Your Advantages Over Competitors (Multiple choice)',
                type: 'checkbox',
                options: [
                    {
                        option: 'Price advantage',
                        value: 20000,
                        type: 'potential',
                        sentences: [
                            "A price advantage is often achieved through economies of scale.",
                            "It is more sustainable in businesses involving hardware or manufacturing.",
                            "It allows for rapid market penetration.",
                            "It provides the opportunity to win price-sensitive customer segments.",
                            "However, it is a strategy that can be easily imitated by competitors."
                        ]
                    },
                    {
                        option: 'Technological superiority',
                        value: 20000,
                        type: 'potential',
                        sentences: [
                            "Technological superiority offers a solution that is difficult for competitors to copy.",
                            "It is often expressed as a '10x better' solution.",
                            "It can create a strong 'moat' and defense mechanism in the market.",
                            "It forms the basis for high profit margins and market leadership.",
                            "It requires continuous R&D investment."
                        ]
                    },
                    {
                        option: 'User experience',
                        value: 20000,
                        type: 'potential',
                        sentences: [
                            "Superior user experience (UX) is a critical factor for customer loyalty and viral growth.",
                            "It requires continuous user feedback and iteration.",
                            "It reduces customer churn and creates brand ambassadors.",
                            "It strongly supports organic growth.",
                            "It requires a culture and process that is difficult for competitors to copy."
                        ]
                    },
                    {
                        option: 'Patent or protection',
                        value: 20000,
                        type: 'potential',
                        sentences: [
                            "Intellectual property protection provides an advantage that competitors cannot legally imitate.",
                            "It can create a temporary monopoly or a strong advantage in the market.",
                            "It is an important element that increases the venture's value for investors.",
                            "It acts as a legal protective shield for long-term market dominance.",
                            "However, obtaining and protecting patents can be costly."
                        ]
                    },
                    {
                        option: 'Fast service and support',
                        value: 20000,
                        type: 'potential',
                        sentences: [
                            "Excellent customer service is a significant differentiator, especially in highly competitive markets.",
                            "It increases customer satisfaction and lifetime value (LTV).",
                            "It encourages positive word-of-mouth marketing.",
                            "It plays a key role in building brand loyalty.",
                            "It requires a service culture that exceeds competitors' standards."
                        ]
                    },
                    {
                        option: 'Other',
                        value: 20000,
                        type: 'potential',
                        sentences: [
                            "This category includes other advantages such as unique business models.",
                            "Exclusive and hard-to-copy distribution channels can fall into this scope.",
                            "The personal reputation and network of the founding team can also be an advantage.",
                            "It provides differentiation in an area that is industry-specific, sustainable, and unexpected by competitors.",
                            "It offers the opportunity to achieve a unique position in the market."
                        ]
                    }
                ]
            },
        ]
    },
    {
        title: '4. Prototype / Product Status',
        questions: [
            {
                id: 'q30',
                text: 'Is there an MVP?',
                tooltip: 'MVP: The simplest, working version of the product; developed to quickly test and gather feedback.',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "Having a Minimum Viable Product (MVP) shows that the venture has adopted the Lean Startup methodology.",
                            "An MVP allows the team to test its assumptions with real users and gather valuable feedback.",
                            "This approach offers a low-risk way to validate the business idea before making large investments.",
                            "For investors, the existence of an MVP is proof that the team is taking a data-driven approach to finding product-market fit.",
                            "This significantly reduces the investment risk of the venture and increases its chances of success."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "The absence of an MVP indicates that the venture has not yet begun to test its core business hypotheses.",
                            "This means the team is still operating on assumptions and has not validated the market's interest in the product.",
                            "Continuing the development process without an MVP increases the risk of building a product that customers do not want.",
                            "Investors interpret this as the venture skipping the validated learning process.",
                            "This is a significant deficiency in terms of investability."
                        ]
                    }
                ]
            },
            {
                id: 'q31',
                text: 'Is the product / technology difficult to copy?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Having a product or technology that is difficult to copy creates a sustainable competitive advantage or 'moat'.",
                            "This defensibility can stem from factors such as patented technology, complex algorithms, or proprietary data sets.",
                            "This makes it difficult for competitors to enter the market and allows the venture to protect its market share.",
                            "Investors see such defensible assets as a strong indicator of the venture's potential to create long-term value.",
                            "This strengthens the company's position in the market and increases its valuation."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "An easily replicable product leaves the venture under constant competitive pressure.",
                            "Low barriers to entry allow new competitors to quickly enter the market and erode market share.",
                            "In this case, the venture often has to compete in less sustainable areas like price or marketing.",
                            "The lack of a defensible technological advantage makes it difficult to maintain long-term profitability.",
                            "For investors, this is a major concern regarding the venture's ability to create lasting value."
                        ]
                    }
                ]
            },
            {
                id: 'q32',
                text: 'Sales cycle duration',
                type: 'radio',
                options: [
                    {
                        option: '1 month or less',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "A sales cycle of less than one month indicates a highly efficient go-to-market model and enables rapid revenue growth.",
                            "This speeds up cash flow and reduces customer acquisition cost (CAC).",
                            "Short sales cycles often indicate that the product's value proposition is clear and there is strong market traction.",
                            "For investors, this is proof of a scalable business model where capital can be quickly converted into growth.",
                            "It makes the company's growth more predictable."
                        ]
                    },
                    {
                        option: '1-3 months',
                        value: 60000,
                        type: 'potential',
                        sentences: [
                            "A sales cycle of one to three months is a very healthy and manageable period, especially in B2B markets.",
                            "This timeframe allows the company to grow its revenues at a reasonable pace and plan its cash flow.",
                            "The cycle provides enough time to build relationships with customers while minimizing the risks of excessively long waiting periods.",
                            "This is a sign of solid operational efficiency showing stable and scalable growth potential.",
                            "This duration also reflects the market's adoption speed of the product."
                        ]
                    },
                    {
                        option: '3-6 months',
                        value: 40000,
                        type: 'potential',
                        sentences: [
                            "A sales cycle of three to six months is common, especially in complex enterprise sales.",
                            "However, it can create challenges for an early-stage venture.",
                            "This period slows down revenue generation and increases pressure on the company's cash flow.",
                            "This may require more initial capital.",
                            "Investors will want to see strategies developed to shorten this period."
                        ]
                    },
                    {
                        option: '6-12 months',
                        value: 20000,
                        type: 'risk',
                        sentences: [
                            "A sales cycle of six to twelve months is a significant risk for an early-stage venture.",
                            "Such a long period severely delays revenue generation and quickly depletes the company's 'runway'.",
                            "This significantly increases the customer acquisition cost (CAC) and makes the return on investment (ROI) uncertain.",
                            "Investors see such a long cycle as a major concern regarding the business model's scalability.",
                            "This duration may indicate serious inefficiencies in the product-market fit or sales process."
                        ]
                    },
                    {
                        option: '12 months or more',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "A sales cycle longer than twelve months is unsustainable for a startup and is generally considered uninvestable.",
                            "Such a long payback period maximizes the risk of the company exhausting all its capital before generating revenue.",
                            "This may indicate that the product-market fit is weak or the value proposition is not clear.",
                            "Another possible reason is that the target market is not ready to adopt the product.",
                            "This is a strong indicator that the business model is fundamentally flawed and cannot be scaled."
                        ]
                    }
                ]
            },
            {
                id: 'q33',
                text: 'How quickly can you improve your product based on customer feedback?',
                type: 'radio',
                options: [
                    {
                        option: 'Very fast, regular updates',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "Adapting very quickly to customer feedback demonstrates an agile and customer-centric culture.",
                            "This is proof that the company is effectively implementing the 'Build-Measure-Learn' cycle.",
                            "This ability ensures continuous product improvement and increased customer satisfaction.",
                            "It helps maintain a competitive advantage.",
                            "Investors evaluate this adaptation speed as an important indicator of the team's execution ability."
                        ]
                    },
                    {
                        option: 'Medium speed, occasional updates',
                        value: 35000,
                        type: 'potential',
                        sentences: [
                            "A medium speed of adaptation shows that the company considers customer feedback but its processes are not fully optimized.",
                            "This can cause delays in capturing market opportunities.",
                            "It can be slow to respond to competitive threats.",
                            "The venture has the potential to accelerate its development and feedback cycles.",
                            "This is a manageable situation but may prevent the company from reaching its full potential."
                        ]
                    },
                    {
                        option: 'Slow, rare updates',
                        value: 12500,
                        type: 'risk',
                        sentences: [
                            "Responding slowly to feedback indicates being disconnected from the market and risking falling behind the competition.",
                            "This can lead to customers' needs not being met and them turning to competitors over time.",
                            "A slow iteration speed shows that the team is not agile and the learning cycle is inefficient.",
                            "For investors, this is a serious concern regarding the venture's ability to adapt to market dynamics.",
                            "This increases the risk of the product becoming irrelevant over time."
                        ]
                    },
                    {
                        option: 'No updates are made',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Not responding to customer feedback at all is a sign that the product and the company are stagnant.",
                            "This means that the needs of the market and customers are completely ignored.",
                            "This approach inevitably leads to the product becoming irrelevant and customer churn.",
                            "This is an unacceptable situation for investors.",
                            "It shows that the venture has a fundamentally flawed management approach."
                        ]
                    }
                ]
            },
            {
                id: 'q34',
                text: 'Is the go-to-market strategy clear?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A clear go-to-market (GTM) strategy shows that the team understands how to reach its target customer.",
                            "This clarity ensures that marketing and sales efforts are focused and efficient.",
                            "A good GTM strategy includes target market segments, value proposition, pricing, and distribution channels.",
                            "For investors, this is proof that the team has a strategic plan not just for a product, but for building a business.",
                            "This means resources are used effectively."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "The absence of a clear go-to-market strategy creates great uncertainty and execution risk.",
                            "If the team allocates resources without knowing how to reach its target customer, these efforts are likely to be wasted.",
                            "This usually leads to slow growth and high customer acquisition costs.",
                            "The risk of not gaining market share increases.",
                            "Investors see the lack of a strategic roadmap as a sign that the team lacks commercial acumen."
                        ]
                    }
                ]
            },
            {
                id: 'q35',
                text: 'Is there experience in different markets?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "Having experience in different markets demonstrates the venture's ability to adapt and scale.",
                            "This proves that the business model is not overly dependent on a single market and has broader growth potential.",
                            "This experience shows the company's capacity to understand different market dynamics and customer behaviors.",
                            "For investors, this is a sign of a diversified growth strategy and lower market concentration risk.",
                            "It also proves the ability to adapt to different regulatory environments."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Concentrating experience in a single market leaves the venture vulnerable to that market's dynamics.",
                            "A downturn in the market or increased competition could risk the entire company.",
                            "Regulatory changes can also pose a serious threat.",
                            "Lack of experience in different markets raises questions about the venture's ability to scale.",
                            "Investors may see this as a factor that limits growth potential and increases risk."
                        ]
                    }
                ]
            },
            {
                id: 'q36',
                text: 'Is the business model scalable?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A scalable business model means that revenue can grow significantly faster than costs.",
                            "This is a fundamental requirement for venture capital investment.",
                            "Models like Software-as-a-Service (SaaS) are naturally scalable due to low marginal costs.",
                            "This allows for high profit margins and exponential growth.",
                            "Scalability indicates the venture's potential to serve a large market and provide a significant return on investment."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "A non-scalable business model means that growth is directly tied to an increase in costs.",
                            "Such service or consulting-oriented businesses can be profitable, but they generally cannot achieve the exponential growth that venture capital seeks.",
                            "The linear nature of growth potential limits the return on investment.",
                            "This makes it less attractive for venture capital.",
                            "This type of model is often considered a 'lifestyle business' and is not suitable for large-scale investment."
                        ]
                    }
                ]
            },
            {
                id: 'q37',
                text: 'Is there potential to create multiple revenue sources?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 25000,
                        type: 'potential',
                        sentences: [
                            "The potential for multiple revenue streams increases the flexibility and resilience of the business model.",
                            "This allows the company to diversify its revenue and reduce dependency on a single source of income.",
                            "It offers the potential to increase customer lifetime value (LTV).",
                            "For example, a software company could offer data analytics services in addition to subscription fees.",
                            "For investors, this is a positive signal indicating a more robust financial structure and additional growth paths."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Being dependent on a single revenue stream makes the business more vulnerable to market changes.",
                            "Changes in customer preferences or competitive pressures pose serious risks.",
                            "This increases revenue concentration risk and limits growth potential.",
                            "It is important for the venture to explore ways to diversify its revenue streams to ensure long-term sustainability.",
                            "Investors may see this as an indicator that the business model's flexibility is limited."
                        ]
                    }
                ]
            },
            {
                id: 'q38',
                text: 'Have you made any sales of your product?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 125000,
                        type: 'potential',
                        sentences: [
                            "Actual sales are the most important validation point in a venture's progress.",
                            "This proves that customers are willing to pay for the product; this is the most concrete step towards product-market fit.",
                            "Sales show that the business model is viable and the value proposition resonates.",
                            "For investors, first sales are the strongest signal that significantly reduces market risk.",
                            "This means moving beyond assumptions and achieving real market validation."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Having no sales yet indicates that the venture is still in its riskiest stage.",
                            "It is uncertain whether the market will adopt the product and be willing to pay for it.",
                            "This means that product-market fit has not yet been validated.",
                            "The lack of sales is the biggest source of uncertainty for investors.",
                            "The venture's most urgent priority should be to validate this fundamental assumption by finding the first paying customers."
                        ]
                    }
                ]
            },
        ]
    },
    {
        title: '5. Intellectual Property and Psychology',
        questions: [
            {
                id: 'q40',
                text: 'Does the company have its own intellectual property rights?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "Full ownership of the intellectual property (IP) by the company secures one of the venture's most valuable assets and prevents future legal disputes.",
                            "This is a fundamental due diligence item for investors, as uncertainty in IP ownership can block investment.",
                            "Clear agreements where all founders and employees have assigned their IP to the company show that the company has full control over its core assets.",
                            "This legal clarity is a critical element that directly affects the company's valuation and defensibility.",
                            "Securing the IP helps protect the company's long-term competitive advantage."
                        ]
                    },
                    {
                        option: 'Application in progress',
                        value: 25000,
                        type: 'potential',
                        sentences: [
                            "Having applied for intellectual property protection is a positive sign that the team is aware of the importance of IP.",
                            "This shows that proactive steps are being taken to protect it.",
                            "Although not yet registered, the application process demonstrates the company's intent to protect its assets.",
                            "However, there is still some uncertainty and risk as there is no guarantee the application will be approved.",
                            "Investors will closely monitor the status of the application process and its likelihood of success."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "The company not owning its intellectual property is a major legal and commercial risk.",
                            "This means the venture's core technology or brand is open to claims by others.",
                            "This uncertainty is an unacceptable risk for investors and usually a deal-breaker.",
                            "Not protecting intellectual property leaves the company's most valuable assets vulnerable.",
                            "It undermines the ability to build a long-term competitive advantage."
                        ]
                    }
                ]
            },
            {
                id: 'q41',
                text: 'Have you obtained certifications for your product? (CE, ISO, etc.)',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "Obtaining industry-specific certifications like CE or ISO is strong proof of the product's compliance with quality and safety standards.",
                            "This shows that a critical barrier to market entry has been overcome, especially in highly regulated sectors like health-tech.",
                            "Certifications increase the product's credibility and build trust with customers.",
                            "They can be a prerequisite for accessing certain markets.",
                            "For investors, this is a sign that a significant regulatory risk has been overcome and the product is ready for commercialization."
                        ]
                    },
                    {
                        option: 'Application in progress',
                        value: 25000,
                        type: 'potential',
                        sentences: [
                            "Having applied for certification shows that the team is aware of regulatory requirements.",
                            "This is a positive step, but the certification process itself can be time-consuming and costly.",
                            "The uncertainty of the outcome is a risk factor.",
                            "The risk of rejection or delay in the application can postpone the product's market launch.",
                            "Investors do not consider the regulatory risk fully eliminated until final approval is obtained."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Not having the necessary certifications is a major red flag, especially in regulated industries.",
                            "This may mean that the product cannot be legally marketed.",
                            "It raises suspicions that it does not meet important safety and quality standards.",
                            "This deficiency creates serious doubts about the venture's ability to commercialize.",
                            "The team ignoring this critical step may indicate their inexperience with industry requirements."
                        ]
                    }
                ]
            },
            {
                id: 'q42',
                text: 'What is your company\'s legal entity type?',
                type: 'radio',
                options: [
                    {
                        option: 'Joint-Stock Company (JSC)',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A Joint-Stock Company (JSC) structure is the gold standard for startups seeking venture capital investment.",
                            "This structure provides flexibility for issuing stock and creating employee stock option plans (ESOPs).",
                            "Investors view the JSC structure as the most suitable for corporate governance and scalability.",
                            "It is also the most appropriate structure for a future initial public offering (IPO) or merger and acquisition (M&A).",
                            "Choosing this legal structure shows that the team is thinking big and is prepared for the venture capital journey."
                        ]
                    },
                    {
                        option: 'Limited Liability Company (LLC)',
                        value: 40000,
                        type: 'risk',
                        sentences: [
                            "A Limited Liability Company (LLC) is a common choice for starting out but is not ideal for venture capital investment.",
                            "Share transfers and the addition of new investors are more cumbersome and costly compared to a JSC.",
                            "Many investors will require the company to be converted into a JSC before investing.",
                            "This conversion means additional legal costs and loss of time.",
                            "This structure can be seen as an obstacle in the early stages of the venture capital journey."
                        ]
                    },
                    {
                        option: 'Sole Proprietorship',
                        value: 20000,
                        type: 'risk',
                        sentences: [
                            "A sole proprietorship does not create a legal distinction between the founder's personal assets and the company's debts.",
                            "This unlimited liability is an unacceptable risk for both the founder and potential investors.",
                            "Additionally, this structure cannot issue stock.",
                            "It cannot scale by taking external capital.",
                            "Investors view this structure as unprofessional and uninvestable."
                        ]
                    },
                    {
                        option: 'Ordinary Partnership',
                        value: 10000,
                        type: 'risk',
                        sentences: [
                            "An ordinary partnership is a structure without legal personality where partners are jointly liable for company debts.",
                            "Similar to a sole proprietorship, this creates a significant personal financial risk for the founders.",
                            "It is completely inadequate for scaling and raising investment.",
                            "It does not offer the possibility of creating a corporate structure.",
                            "It is not considered a suitable structure for building a serious business in the entrepreneurial ecosystem."
                        ]
                    },
                    {
                        option: 'Not yet established',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "The company not being legally established yet indicates that the venture is still in the idea stage.",
                            "It means it has not started operations.",
                            "Investors generally do not invest without a legal entity.",
                            "This may indicate that the team has delayed in taking the business seriously.",
                            "The first step to proceed with the investment process will be to establish the appropriate legal structure."
                        ]
                    },
                    {
                        option: 'Other',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Non-standard legal structures can complicate investment processes.",
                            "Investors may be reluctant to invest in structures they are not familiar with.",
                            "Such structures can create legal difficulties in matters like share transfers or adding new partners.",
                            "The venture needs to clearly explain why it did not choose a standard structure.",
                            "This means an additional due diligence burden for investors."
                        ]
                    }
                ]
            },
            {
                id: 'q43',
                text: 'Do the founders have due diligence documents?',
                type: 'radio',
                options: [
                    {
                        option: 'Yes',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "Founders having all necessary documents ready for the due diligence process is a sign of professionalism and preparedness.",
                            "This significantly speeds up the investment process.",
                            "It gives the investor confidence that the team is organized and transparent.",
                            "Complete documentation suggests that potential legal or operational issues have been resolved in advance.",
                            "This leaves a positive impression on the investor and helps the deal proceed smoothly."
                        ]
                    },
                    {
                        option: 'No',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Not having due diligence documents ready causes significant delays in the investment process.",
                            "This can create the impression that the team is unprepared or disorganized.",
                            "Worse, unexpected legal issues that may arise during this process can cause the investor to withdraw from the deal.",
                            "For example, Intellectual Property ownership issues or irregular accounting records can create serious problems.",
                            "Unpreparedness can shake the investor's confidence in the team and jeopardize the entire process."
                        ]
                    }
                ]
            },
            {
                id: 'q44',
                text: 'What is the company\'s financial resource and cash management situation?',
                type: 'radio',
                options: [
                    {
                        option: 'Sufficient financial resources and healthy cash flow',
                        value: 130000,
                        type: 'potential',
                        sentences: [
                            "Having sufficient financial resources shows that the venture is operationally stable.",
                            "A healthy cash flow proves that the company has enough 'runway' to focus on its strategic goals.",
                            "This ensures the company is resilient against unexpected expenses or revenue delays.",
                            "Healthy cash management is proof that the team has financial discipline and foresight.",
                            "For investors, this is the most positive financial scenario, indicating that their capital will be used to accelerate growth."
                        ]
                    },
                    {
                        option: 'Resources are limited, but manageable',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "Having limited but manageable resources is a common situation for early-stage ventures.",
                            "This means the team must manage its resources carefully and prioritize its spending.",
                            "Cash flow must be monitored closely, and a buffer should be maintained for unexpected situations.",
                            "This can be a concern for investors, but it can also show that the team is frugal.",
                            "The timing of the investment becomes critical in this scenario."
                        ]
                    },
                    {
                        option: 'Financial resources are insufficient and at risk',
                        value: 20000,
                        type: 'risk',
                        sentences: [
                            "Insufficient financial resources indicate that the venture is facing a survival threat.",
                            "This means the company is at risk of not being able to pay salaries or going bankrupt.",
                            "This financial instability distracts the team from strategic goals and shifts the entire focus to 'survival'.",
                            "For investors, this is an extremely high-risk situation.",
                            "It often requires an urgent 'bridge financing', which can mean unfavorable terms for existing shareholders."
                        ]
                    }
                ]
            },
            {
                id: 'q45',
                text: 'As partners, how often do you experience emotional burnout due to workload and responsibilities?',
                type: 'radio',
                options: [
                    {
                        option: 'Never',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "Founders not experiencing emotional burnout indicates a high level of resilience and effective stress management skills.",
                            "This shows that the founders can maintain a healthy balance between their personal health and work demands.",
                            "Research shows that founder burnout is one of the leading causes of startup failure.",
                            "Low levels of burnout are a very positive signal for the long-term health of the venture.",
                            "This psychological resilience enhances the effectiveness of the leadership team and the sustainability of the company."
                        ]
                    },
                    {
                        option: 'Rarely',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "Experiencing burnout rarely indicates a high level of resilience and effective stress management skills.",
                            "This shows that the founders can maintain a healthy balance between their personal health and work demands.",
                            "Research shows that founder burnout is one of the leading causes of startup failure.",
                            "Low levels of burnout are a very positive signal for the long-term health of the venture.",
                            "This psychological resilience enhances the effectiveness of the leadership team and the sustainability of the company."
                        ]
                    },
                    {
                        option: 'Sometimes',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "Experiencing occasional burnout is a natural part of the entrepreneurial journey and is a manageable situation.",
                            "This shows that the founders are under intense pressure from time to time but can generally cope with it.",
                            "However, this can be a sign of potential risks.",
                            "It indicates that the team should proactively develop stress management strategies.",
                            "Measures should be taken to prevent this situation from progressing to 'frequently' or 'always'."
                        ]
                    },
                    {
                        option: 'Frequently',
                        value: 25000,
                        type: 'risk',
                        sentences: [
                            "Frequent burnout is a serious warning sign that the founders are working at an unsustainable pace.",
                            "It shows that their personal well-being is at risk.",
                            "This can negatively affect the quality of decision-making and intra-team relationships.",
                            "This level of burnout often points to serious problems in work-life balance.",
                            "The continuation of this situation poses a serious threat to both the founders' health and the company's future."
                        ]
                    },
                    {
                        option: 'Always',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "A state of constant burnout is a critical situation indicating that the founders have reached their limits both mentally and physically.",
                            "This means the leadership team is at risk of becoming dysfunctional.",
                            "There is a high risk of the company losing its strategic direction.",
                            "This level of burnout is often a precursor to inevitable failure.",
                            "For investors, this is a clear indicator that the venture is fundamentally unstable and unmanageable."
                        ]
                    }
                ]
            },
            {
                id: 'q46',
                text: 'How would you assess the partners\' overall motivation, satisfaction and psychological state?',
                type: 'radio',
                options: [
                    {
                        option: 'The partners\' motivation, mental state and life satisfaction are very high.',
                        value: 100000,
                        type: 'potential',
                        sentences: [
                            "The very good general psychological well-being of the founders shows their high capacity to cope with challenges.",
                            "It proves their ability to stay calm under pressure and maintain a positive outlook.",
                            "High life satisfaction is associated with better decision-making and increased creativity.",
                            "This creates a positive foundation not only for the founders' personal health but also for the company's culture and performance.",
                            "This indicates that the team will be resilient to the ups and downs of entrepreneurship."
                        ]
                    },
                    {
                        option: 'They are generally satisfied; minor stress or issues do not affect operations.',
                        value: 75000,
                        type: 'potential',
                        sentences: [
                            "A good level of psychological well-being shows that the founders are in a generally healthy mental state.",
                            "It proves that they can cope with the demands of the job.",
                            "This provides a solid foundation for stable leadership and effective management.",
                            "This level is a positive indicator for sustainable performance.",
                            "It indicates that the team can maintain its resilience in the face of challenges."
                        ]
                    },
                    {
                        option: 'Neither clearly satisfied nor dissatisfied; the situation varies from period to period.',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A moderate level of psychological well-being may indicate that some stress factors are beginning to affect the founders.",
                            "This has the potential to negatively affect their performance or decision-making abilities.",
                            "This is a warning sign that may require proactive support and intervention.",
                            "It is important for the team to take steps to improve their well-being.",
                            "This situation needs to be improved for long-term success."
                        ]
                    },
                    {
                        option: 'Low motivation, stress and dissatisfaction are clearly visible.',
                        value: 25000,
                        type: 'risk',
                        sentences: [
                            "Low psychological well-being indicates that the founders are in significant mental distress.",
                            "This seriously jeopardizes their leadership capacity and decision-making abilities.",
                            "It negatively affects their ability to manage the company in general.",
                            "This is a high-risk factor at both the individual and corporate levels.",
                            "Investors evaluate this situation as the venture's leadership being fundamentally weak."
                        ]
                    },
                    {
                        option: 'The partners\' motivation and life satisfaction are very low; this negatively affects business processes.',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "Low psychological well-being indicates that the founders are in significant mental distress.",
                            "This seriously jeopardizes their leadership capacity and decision-making abilities.",
                            "It negatively affects their ability to manage the company in general.",
                            "This is a high-risk factor at both the individual and corporate levels.",
                            "Investors evaluate this situation as the venture's leadership being fundamentally weak."
                        ]
                    }
                ]
            },
            {
                id: 'q47',
                text: 'How would you describe the emotional and social support you receive from those around you?',
                type: 'radio',
                options: [
                    {
                        option: 'Strong',
                        value: 50000,
                        type: 'potential',
                        sentences: [
                            "A strong emotional and social support network is a vital resource for entrepreneurs to cope with the intense stress they face.",
                            "This network increases resilience and prevents burnout.",
                            "It provides an external perspective and encouragement during tough times.",
                            "Having a strong support system helps founders maintain their mental health.",
                            "Investors see this factor as an indicator of the founder's personal resilience."
                        ]
                    },
                    {
                        option: 'Medium',
                        value: 40000,
                        type: 'potential',
                        sentences: [
                            "A medium-level support network indicates that the founders have some support but this network can be strengthened.",
                            "It would be beneficial for the founders to seek additional resources like mentoring.",
                            "It is important for them to be proactive about stress management and resilience.",
                            "While this network provides basic support, it may be insufficient in times of intense crisis.",
                            "Consciously developing this network is important for long-term success."
                        ]
                    },
                    {
                        option: 'Weak',
                        value: 15000,
                        type: 'risk',
                        sentences: [
                            "A weak support network means that the founders are struggling with stress and challenges on their own.",
                            "This significantly increases the risk of burnout and mental health issues.",
                            "Being alone in decision-making processes increases the likelihood of making wrong decisions.",
                            "Investors see this situation as a risk factor for the founder's resilience and long-term performance.",
                            "The entrepreneur urgently needs to seek mentors, advisors, or support groups."
                        ]
                    },
                    {
                        option: 'Very weak',
                        value: 0,
                        type: 'risk',
                        sentences: [
                            "A very weak support network is a serious red flag indicating that the founder is in isolation.",
                            "This significantly increases the risk of burnout and mental health issues.",
                            "Being alone in decision-making processes increases the likelihood of making wrong decisions.",
                            "Investors see this situation as a risk factor for the founder's resilience and long-term performance.",
                            "The entrepreneur urgently needs to seek mentors, advisors, or support groups."
                        ]
                    }
                ]
            },
        ]
    },
];

export default surveyData_en;